module.exports = __webpack_public_path__ + "img/type4_bg_1.9837ee0e.png";